module.exports = __webpack_public_path__ + "img/4_34.0f29962f.png";